var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666656 9C0.666656 4.39762 4.39762 0.666664 8.99999 0.666664C11.2101 0.666664 13.3297 1.54464 14.8925 3.10744C16.4553 4.67024 17.3333 6.78986 17.3333 9C17.3333 13.6024 13.6024 17.3333 8.99999 17.3333C4.39762 17.3333 0.666656 13.6024 0.666656 9ZM9.00015 9.83325H12.3335C12.7937 9.83325 13.1668 9.46015 13.1668 8.99992C13.1668 8.53968 12.7937 8.16658 12.3335 8.16658H9.83349V5.66658C9.83349 5.20635 9.46039 4.83325 9.00015 4.83325C8.53992 4.83325 8.16682 5.20635 8.16682 5.66658V8.99992C8.16682 9.46015 8.53992 9.83325 9.00015 9.83325Z",
    fill: "#8E9EAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusInProgress);
export default __webpack_public_path__ + "static/media/status-in-progress.6af30462487718b821967edbe25b86a2.svg";
export { ForwardRef as ReactComponent };